import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { HeaderProps } from '../../types/components';
import WeatherTime from '../ui/WeatherTime';

const Header: React.FC<HeaderProps> = ({ currentPage, navigationTabs }) => {
  const { accounts } = useMsal();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const getUserName = () => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      return (account.idTokenClaims as any)?.given_name || account.name || account.username || "User";
    }
    return "User";
  };



  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      {/* Main Header */}
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16">
        <div className="flex justify-between items-center py-4">
          {/* HCLTech Branding */}
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0">
              <h1 className="text-2xl font-bold text-blue-600">
                HCLTech
              </h1>
              <p className="text-sm text-gray-600 font-medium">
                AWS Business Unit
              </p>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigationTabs.map((tab) => (
              <Link
                key={tab.id}
                to={tab.href}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                  tab.isActive
                    ? 'text-blue-600 bg-blue-50 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                {tab.label}
              </Link>
            ))}
          </nav>

          {/* User Profile */}
          <div className="hidden md:flex items-center ml-4">
             <span className="text-sm text-gray-700 font-medium">Welcome, {getUserName()}</span>
             <WeatherTime />
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {/* Hamburger icon */}
              <svg
                className={`${isMobileMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              {/* Close icon */}
              <svg
                className={`${isMobileMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div className={`md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-50 border-t border-gray-200">
          {navigationTabs.map((tab) => (
            <Link
              key={tab.id}
              to={tab.href}
              className={`block px-3 py-2 text-base font-medium rounded-md transition-colors duration-200 ${
                tab.isActive
                  ? 'text-blue-600 bg-blue-100'
                  : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;